import React, { useCallback } from 'react';
import { createPortal } from 'react-dom';
import { Handle, Position, useReactFlow, NodeResizer } from '@xyflow/react';
import { FaInfoCircle } from 'react-icons/fa';

import PropTypes from 'prop-types';

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

function ImpactNode({ id, data, isConnectable, selected, width, height }) {
  const { deleteElements } = useReactFlow();
  const [currentModal, setCurrentModal] = React.useState(null);

  const onChange = useCallback(
    (e) => {
      data.value = e.target.value;
    },
    [data],
  );

  function openModal(event) {
    if (data.value) {
      event.preventDefault();
      setCurrentModal(event.target.getAttribute('data-modal-id'));
    }
    else {
      removeNode();
    }
  }

  function closeModal() {
    setCurrentModal(null);
  }

  function closeModalDeleteNode() {
    setCurrentModal(null);
    removeNode();
  }

  const removeNode = useCallback(() => {
    deleteElements({ nodes: [{ id }] });
  }, [id, deleteElements])

  return (
    <>
      <div className="conversation-canvas-node conversation-canvas-node--impact" style={{ height: height || 'auto' }}>
        <NodeResizer
          maxWidth={500}
          minHeight={108}
          minWidth={100}
          isVisible={selected && !data.hasOwnProperty('locked')}
          color='#3ab54a'
          handleStyle={{ width: '10px', height: '10px' }}
        />
        <Handle
          type="source"
          position={Position.Top}
          id="control-target"
          isConnectable={isConnectable}
          className="conversation-canvas-node__handle conversation-canvas-node__handle--impact"
        />
        <div className="conversation-canvas-node__title conversation-canvas-node__title--impact">
          <div className="conversation-canvas-impact-node-title-text">
            Impact{' '}
            <span className="conversation-canvas-impact-node-info-icon" title="Click for more information about Impact boxes">
              <FaInfoCircle size={16} color="#FFFFFF" />
            </span>
          </div>
          {!data.hasOwnProperty('locked') && (
            <button
              className="canvas-category-controls-and-actions-section-item__delete-button"
              onClick={openModal}
              onKeyDown={openModal}
              data-modal-id="delete-node-modal">
              X
            </button>
          )}
        </div>
        <div className="conversation-canvas-node-content">
          <div>
            <textarea
              className="conversation-canvas-node-content__input nodrag"
              id="text"
              name="text"
              maxLength="500"
              onChange={onChange}
              defaultValue={data.value}
              readOnly={data.locked}
              style={{
                width: width - 16,
                minWidth: width - 16,
                height: height - 57 || 'auto',
                minHeight: height - 57 || 'auto',
                resize: 'none',
              }}
            ></textarea>
          </div>
        </div>

        <Handle
          type="source"
          position={Position.Left}
          id="control-source-left"
          isConnectable={isConnectable}
          className="conversation-canvas-node__handle conversation-canvas-node__handle--impact"
        />
        <Handle
          type="source"
          position={Position.Right}
          id="control-source-right"
          isConnectable={isConnectable}
          className="conversation-canvas-node__handle conversation-canvas-node__handle--impact"
        />
        <Handle
          type="source"
          position={Position.Bottom}
          id="control-source"
          isConnectable={isConnectable}
          className="conversation-canvas-node__handle conversation-canvas-node__handle--impact"
        />
      </div>
        {currentModal === 'delete-node-modal' &&
          createPortal(
            <div className="modal fade show d-block" tabIndex="-1" aria-modal="true" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content" style={{ borderRadius: 8, overflow: 'hidden' }}>
                  <div style={{ position: 'relative', padding: '0 24px 0 24px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', minHeight: 56, borderBottom: '1px solid #e5e5e5', padding: '16px 0' }}>
                      <div style={{ flex: 1, textAlign: 'center', fontWeight: 700, fontSize: 20 }}>
                        Delete Node
                      </div>
                      <button
                        type="button"
                        aria-label="Close"
                        onClick={closeModal}
                        style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', fontSize: 24, cursor: 'pointer', lineHeight: 1 }}
                      >
                        &times;
                      </button>
                    </div>
                    <div style={{ padding: '10px 0', textAlign: 'center' }}>
                      <p>This action cannot be undone.</p>
                    </div>
                    <div className="mb-3" style={{ display: 'flex', justifyContent: 'center', gap: 16}}>
                      <button
                        onClick={closeModal}
                        className="page-content__button--medium page-content__button--secondary"
                        id="page-function-button--modal-close-delete-node-modal"
                        type="button"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={closeModalDeleteNode}
                        className="page-content__button--medium page-content__button--danger"
                        id="page-function-button--modal-delete-and-close-delete-node-modal"
                        type="button"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>,
            document.body
          )
        }
    </>
  );
}

export default ImpactNode;

ImpactNode.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.object,
  isConnectable: PropTypes.bool.isRequired,
  selected: PropTypes.bool,
  width: PropTypes.any,
  height: PropTypes.any
}